import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handleShow = this.handleShow.bind(this)
    window.addEventListener("owner:toast", this.handleShow)
    window.showToast = (message, type = "success", variant = "light") => {
      window.dispatchEvent(new CustomEvent("owner:toast", { detail: { message, type, variant } }))
    }
  }

  disconnect() {
    window.removeEventListener("owner:toast", this.handleShow)
    if (window.showToast) {
      delete window.showToast
    }
  }

  handleShow(event) {
    const message = event.detail?.message?.toString().trim()
    const type = event.detail?.type === "error" ? "error" : "success"
    const variant = event.detail?.variant === "dark" ? "dark" : "light"
    if (!message) return

    this.element.insertAdjacentHTML("afterbegin", this.toastMarkup(message, type, variant))
  }

  toastMarkup(message, type, variant) {
    return `
      <div
        class="owner-toast owner-toast--${type} owner-toast--${variant}"
        data-controller="toast"
        data-toast-duration-value="3000"
        data-state="hidden"
        role="status"
      >
        <span class="owner-toast__dot" aria-hidden="true"></span>
        <span class="owner-toast__message">${this.escapeHtml(message)}</span>
      </div>
    `
  }

  escapeHtml(value) {
    return value
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;")
  }
}
